import {AxiosError} from "axios";
import AuthService from "../../auth/services/auth.service";
import {CustomAxiosRequestConfig} from "@libs/axios";
import NotificationService from "@common/services/notification.service";
import {ErrorHandler, ErrorHandlers, StatusCode} from "../models/interfaces/error-handler.type";

export interface CustomError {
    code: string;
    message: string;
}

export const isCustomError = (error: any) => (
    typeof error === "object" &&
    error !== null &&
    typeof error.code === "string" &&
    typeof error.message === "string"
)

class ErrorHandling {
    public handlers: ErrorHandlers = {};

    constructor() {
        this.addDefaultHandlers();
    }

    public handle(error: AxiosError): void {
        const status = error.response?.status;
        if (status && this.shouldUseCustomHandler(status, error)) {
            this.handlers[status](error);
        } else {
            this.handleDefault(error);
        }
    }

    public handleDefault(error: AxiosError): void {
        const customMessage = (error.config as CustomAxiosRequestConfig)?.errorMessage;
        // @ts-ignore
        const errorMessageApi: string = error.response?.data.message;
        const defaultErrorMessage: string = customMessage || errorMessageApi || "Wystąpił nieoczekiwany błąd.";
        NotificationService.error(defaultErrorMessage, error);
        console.error('Default error handling:', error);
    }

    public shouldUseCustomHandler(status: StatusCode, error: AxiosError): boolean {
        const customHandlingConfig = {
            404: 'skipDefault404Handling',
            401: 'skipDefault401Handling'
        };

        const skipConfigKey = customHandlingConfig[status as keyof typeof customHandlingConfig];
        const shouldSkip = !!(error.response?.config as any)?.[skipConfigKey]
        return skipConfigKey ? !shouldSkip : false;
    }

    private addHandler(statusCode: StatusCode, handler: ErrorHandler): void {
        this.handlers[statusCode] = handler;
    }

    private addDefaultHandlers(): void {
        this.addHandler(401, this.handleUnauthorized);
        this.addHandler(404, this.handleNotFound);
    }

    private handleUnauthorized = (): void => {
        AuthService.logout();
        NotificationService.error("Sesja wygasła. Zaloguj się ponownie.");
    }

    private handleNotFound = (): void => {
        window.location.href = '/not-found';
    }

}

const errorHandling = new ErrorHandling();
export default errorHandling;
